var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#201D1D",
  fillRule: "evenodd",
  d: "M.285.285a.97.97 0 0 1 1.374 0L7.5 6.126 13.341.285a.972.972 0 0 1 1.374 1.374L8.874 7.5l5.841 5.841c.35.35.378.902.081 1.283l-.08.091a.97.97 0 0 1-1.375 0L7.5 8.874l-5.841 5.841a.972.972 0 0 1-1.374-1.374L6.126 7.5.285 1.659A.97.97 0 0 1 .204.376z"
})));
export default SvgIconX;